/* DO NOT MODIFY. This is an autogenerated file. */
/* eslint-disable */
import * as React from "react"
import type { SVGProps } from "react"

export const SvgBankPlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || "100%"}
    height={props.height || "100%"}
    fill="none"
    viewBox="0 0 24 24"
    data-name="SvgBankPlus"
    {...props}
  >
    {props.children}
    <clipPath id="bank-plus_svg__a">
      <path d="M0 0h24v24H0z" />
    </clipPath>
    <g clipPath="url(#bank-plus_svg__a)">
      <path
        stroke="#0d0d0d"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M13 19.476H3.1c-.56 0-.84 0-1.054-.11a1 1 0 0 1-.437-.436c-.109-.214-.109-.494-.109-1.054v-.8c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437c.214-.11.494-.11 1.054-.11H13v-8m-9.5 0v8m4.5-8v8m9.5-8v5.1m.2 3.1v2m0 0v2m0-2h-2m2 0h2M10.153 1.553l-7.4 1.644c-.447.1-.67.15-.838.27a1 1 0 0 0-.334.416c-.081.19-.081.418-.081.876v1.117c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437c.214.109.494.109 1.054.109h14.8c.56 0 .84 0 1.054-.11a1 1 0 0 0 .437-.436c.109-.214.109-.494.109-1.054V4.759c0-.458 0-.687-.081-.876a1 1 0 0 0-.334-.417c-.167-.12-.39-.17-.838-.269l-7.4-1.644a2 2 0 0 0-.26-.05 1 1 0 0 0-.174 0c-.066.007-.13.02-.26.05M22.7 17.675a5 5 0 1 1-10 0 5 5 0 0 1 10 0"
      />
    </g>
  </svg>
)
